import { createContext, useContext } from "react";
import type { AppConfig } from "./authConfig";

/**
 * Context for the validated runtime configuration. Separated from AuthProvider
 * so that react-refresh (HMR) can treat the provider file as component-only.
 */
export const AuthConfigContext = createContext<AppConfig | null>(null);

/**
 * Consumes the validated runtime configuration. Throws if called outside an
 * AuthProvider — a hard failure is correct here: code that depends on config
 * cannot meaningfully continue without it.
 */
export function useAuthConfig(): AppConfig {
    const value = useContext(AuthConfigContext);
    if (value === null) {
        throw new Error("useAuthConfig must be called within <AuthProvider>.");
    }
    return value;
}
